import { computed, inject, Injectable } from '@angular/core';
import { BaseWorkflowStateService } from '../../base-workflow-state.service';
import { StreamGenrePackData, StreamGenrePackFormData } from '../../../../../../../models/order/workflow/video/stream-genre-pack.model';
import { VideoFlowStateService } from '../video-flow-state.service';
import { VideoProductResponseService } from '../../../order-api-response/video-pd-response.service';

@Injectable({ providedIn: 'root' })
export class StreamGenrePackStateService extends BaseWorkflowStateService<StreamGenrePackData> {
    private flowStateService = inject(VideoFlowStateService);
    private videoPdResponseService = inject(VideoProductResponseService);
    override stateKey: string = 'genrePackageSelection';
    customizations = computed(() => this.videoPdResponseService.getCustomizations()?.filter(cust =>
        cust.customization.DetailedGroupName === 'GenrePacksOptionalOffers' ||
        cust.customization.DetailedGroupName === 'GenreAddOnsOptionalOffers'
    ) || []);

    offers = computed(() => {
        return [(this.state()?.genrePacks || []), (this.state()?.miniPacks || [])].flat();
    });

    genrePackState = computed((): StreamGenrePackFormData => {
        return (this.state()?.genrePacks);
    });
    miniPackState = computed((): StreamGenrePackFormData => {
        return (this.state()?.miniPacks);
    });
    findOfferChoiceCode(choiceCode: string) {
        return this.offers().find(offer => offer?.choiceCode === choiceCode);
    }

    protected override saveLocalDraft(): void {
        this.flowStateService.updateData({ [this.stateKey]: this.state() });
    }

    resetData() {
        this.state.set(null);
        this.saveLocalDraft();
    }
}
